import { render, staticRenderFns } from "./GoodsReturnItems.vue?vue&type=template&id=ccea0cbc&scoped=true"
import script from "./GoodsReturnItems.vue?vue&type=script&lang=js"
export * from "./GoodsReturnItems.vue?vue&type=script&lang=js"
import style0 from "./GoodsReturnItems.vue?vue&type=style&index=0&id=ccea0cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccea0cbc",
  null
  
)

export default component.exports